<template>
  <VLayout
    v-update-main-height
    column
    justify-end
    fill-height
  >
    <VFlex
      xs12
    >
      <VTabs
        centered
        color="grey lighten-4"
        icons-and-text
        slider-color="blue"
        @change="onTabChanged"
      >
        <VTab href="#tab-1">
          Polling ({{ getTotalPolling("tab-1") }})
          <VIcon>mdi-vote</VIcon>
        </VTab>
        <VTabItem
          v-for="i in 1"
          :key="i"
          :value="'tab-' + i"
        >
          <VCard
            flat
            :height="window.height"
            style="overflow: auto"
          >
            <ListViewPage
              :get-gql-query="getGqlQuery"
              :get-current-table-data="getCurrentTableData"
              :get-query-variables="getQueryVariables"
              :update-context-variable="updateContextVariable"
              :fetching-more="isFetchingMore"
              :get-loading-status="getLoadingStatus"
              :set-loading-status="setLoadingStatus"
              :get-status-message="getStatusMessage"
              :set-status-message="setStatusMessage"
              :parse-get-data="parseData"
              :clear-data="clearData"
            >
              <template slot="table">
                <PollingEventTable
                  @fetchingMore="onFetchingMore"
                />
              </template>
            </ListViewPage>
          </VCard>
        </VTabItem>
      </VTabs>
    </VFlex>
  </VLayout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { pollingEventMapActions } from '@/store/modules/polling'
import ListViewPage from '@/pages/ListViewPage'
import PollingEventTable from '@/components/PollingEventTable'
import { LIST_POLLING_EVENTS } from '@/backend/graphql/pollingGQL'
export default {
  name: 'PollingEventsPage',
  components: {
    PollingEventTable, ListViewPage
  },
  directives: {
    'update-main-height': {
      inserted: function (el, binding, vnode) {
        const self = vnode.context
        self.window.initialHeight = el.parentElement.parentElement.clientHeight
        self.window.height = self.window.initialHeight - 93
      }
    }
  },
  data: function () {
    return {
      currentTab: 'tab-1',
      getGqlQuery: LIST_POLLING_EVENTS,
      limit: 50,
      offset: 0,
      orderBy: '-event_date,name',
      isActive: true,
      isFetchingMore: false,
      window: {
        width: 0,
        height: 0,
        initialHeight: 0
      }
    }
  },
  computed: {
    ...mapGetters({
      allPollingEvents: 'polling/getAllPollingEvents',
      userInfo: 'account/getUser'
    })
  },
  created () {
    this.setStatusMessage('Loading Polling Events. Please wait...')
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    this.setEditMenuItems({ val: [] })
    this.setMessageDrawerVisibility({ val: false })
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions(Object.assign(pollingEventMapActions, {
      setEditMenuItems: 'toolBar/setEditMenuItems',
      setMessageDrawerVisibility: 'messageDrawer/setVisibility'
    })),
    getItems (data) { return data.listPollingEvents.results },
    getCurrentTableData () { return this.allPollingEvents },
    getTotalItemsCount (data) { return data.listPollingEvents.totalCount },
    getLoadingStatus () { return this.$store.getters['polling/getLoadingStatus'] },
    setLoadingStatus (val) { this.$store.dispatch('polling/setLoadingStatus', { val }) },
    getStatusMessage () { return this.$store.getters['polling/getLoadingText'] },
    setStatusMessage (message) { this.$store.dispatch('polling/setStatusMessage', { message }) },
    parseData (data) {
      if (this.allPollingEvents.length === 0) {
        this.initPollingEvents({
          newPollingEvents: this.getItems(data),
          totalCount: this.getTotalItemsCount(data),
          isFullArraySize: false
        })
      } else {
        this.appendPollingEvents({
          newPollingEvents: this.getItems(data),
          startIndex: this.getQueryVariables().offset
        })
        this.isFetchingMore = false
      }
    },
    getQueryVariables () {
      return {
        userId: this.userInfo.id,
        limit: this.limit,
        offset: this.offset,
        orderBy: this.orderBy,
        isActive: this.isActive,
        choiceType: this.userInfo.customer_type.includes('FAVORITE') ? 'FAVORITE' : 'LIKE'
      }
    },
    updateContextVariable (key, value) {
      if (this.hasOwnProperty(key)) {
        this[key] = value
      }
    },
    clearData () { this.clearPollingEvents() },
    onFetchingMore () {
      if (!this.isFetchingMore) {
        this.isFetchingMore = true
      }
    },
    getTotalPolling (value) {
      if (value === this.currentTab) {
        return this.$store.getters['polling/getTotalCount']
      } else {
        return '?'
      }
    },
    onTabChanged (value) {
      this.currentTab = value
    },
    handleResize () {
      this.window.width = window.innerWidth
    }
  }
}
</script>

<style scoped>

</style>
